import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-version-notification',
  templateUrl: './version-notification.component.html',
  styleUrls: ['./version-notification.component.scss']
})
export class VersionNotificationComponent {
  @Input() visible: boolean = false;
  @Input() currentVersion: string = '';
  @Input() latestVersion: string = '';
  @Output() refresh = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  get shouldShowNotification(): boolean {
    if (!this.visible || !this.currentVersion || !this.latestVersion) {
      return false;
    }
    return this.latestVersion > this.currentVersion;
  }

  onRefresh(): void {
    this.refresh.emit();
  }

  onClose(): void {
    this.close.emit();
  }
}
